module.exports = __webpack_public_path__ + "static/media/vino.945a18d1.svg";